// src/pages/Location.jsx
import React from 'react';
import { Paper, Typography, Box, Button } from '@mui/material';
import { MapContainer, TileLayer, Marker, AttributionControl } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

const museumPosition = [33.92455, -85.61135];
const destinationAddress = encodeURIComponent(
    '130 N Center Ave, Piedmont, Alabama 36272'
);

const museumIcon = L.icon({
    iconRetinaUrl: markerIcon2x,
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
});

export default function LocationPage() {
    const mapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${destinationAddress}`;

    return (
        <>
            <Paper
                elevation={1}
                sx={{
                    p: { xs: 2, sm: 3, md: 4 },
                    maxWidth: 900,
                    mx: 'auto',
                }}
            >
                <Typography
                    variant="h4"
                    gutterBottom
                    sx={{
                        fontWeight: 700,
                        fontSize: { xs: '1.6rem', sm: '1.8rem' },
                        lineHeight: { xs: 1.25, sm: 1.25 },
                    }}
                >
                    Our Location
                </Typography>

                <Box component="address" sx={{ fontStyle: 'normal', mb: { xs: 1.5, md: 2 } }}>
                    <Typography variant="body1">
                        Piedmont Historical Society Museum
                        <br />
                        130 N Center Ave, Piedmont, Alabama 36272
                    </Typography>
                </Box>

                <Box sx={{ mb: { xs: 2, md: 3 } }}>
                    <Button
                        component="a"
                        href={mapsUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        variant="outlined"
                        sx={{ width: { xs: '100%', sm: 'auto' } }}
                    >
                        Directions
                    </Button>
                </Box>

                {/* Map container */}
                <Box sx={{ height: { xs: 320, sm: 420, md: 500 }, width: '100%' }}>
                    <MapContainer
                        center={museumPosition}
                        zoom={17}
                        scrollWheelZoom={true}   // allow zoom with mouse scroll
                        zoomControl={false}      // remove + / - buttons
                        attributionControl={false}
                        style={{ height: '100%', width: '100%' }}
                    >
                        <TileLayer
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            attribution="© OpenStreetMap contributors"
                        />
                        <Marker position={museumPosition} icon={museumIcon} />
                        <AttributionControl position="bottomright" prefix={false} />
                    </MapContainer>
                </Box>
            </Paper>
        </>
    );
}
